import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { projectService } from '../services';
import { resolveMediaUrl } from '../services/api';
import PageBreadcrumb from '../components/PageBreadcrumb';

const isDonationEligible = (project) => {
    if (!project) return false;
    if (project.status === 'ongoing' || project.status === 'pending') return true;
    if (project.start_date) return new Date(project.start_date) > new Date();
    return false;
};

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProjects();
    }, []);

    const fetchProjects = async () => {
        try {
            const response = await projectService.getAll();
            setProjects(response.data.data || []);
        } catch (error) {
            console.error('Error fetching projects:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-50">
            <PageBreadcrumb
                title="Our Projects"
                description="Making a difference across Pakistan"
                items={[{ label: 'Projects' }]}
            />

            <section className="py-16">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    {loading ? (
                        <div className="py-12 text-center">
                            <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-emerald-600"></div>
                            <p className="mt-4 text-gray-600">Loading projects...</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                            {projects.map((project) => (
                                <div key={project.id} className="soft-enter hover-lift overflow-hidden rounded-lg bg-white shadow-lg transition hover:shadow-xl">
                                    {project.featured_image && (
                                        <img src={resolveMediaUrl(project.featured_image)} alt={project.title} className="h-48 w-full object-cover" />
                                    )}
                                    <div className="p-6">
                                        <h3 className="mb-2 text-xl font-bold text-gray-800">{project.title}</h3>
                                        <p className="mb-4 line-clamp-3 text-sm text-gray-600">{project.description}</p>
                                        <div className="mb-4 flex items-center justify-between text-sm text-gray-500">
                                            <span>{project.location}</span>
                                            <span className={`rounded-full px-3 py-1 text-xs font-semibold text-white ${project.status === 'completed' ? 'bg-green-500' : project.status === 'ongoing' ? 'bg-emerald-500' : 'bg-yellow-500'}`}>
                                                {project.status}
                                            </span>
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <span className="font-bold text-emerald-600">PKR {Number(project.cost || 0).toLocaleString()}</span>
                                            <div className="flex items-center gap-3">
                                                <Link to={`/projects/${project.id}`} className="font-semibold text-emerald-600 hover:text-emerald-700">
                                                    Learn More
                                                </Link>
                                                {isDonationEligible(project) ? (
                                                    <Link
                                                        to="/donate"
                                                        state={{ project }}
                                                        className="rounded bg-emerald-600 px-3 py-1 text-xs font-semibold text-white hover:bg-emerald-700"
                                                    >
                                                        Donate
                                                    </Link>
                                                ) : (
                                                    <span className="rounded bg-gray-200 px-3 py-1 text-xs font-semibold text-gray-600">Closed</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Projects;
